// Общие компоненты состояний списков/экранов: загрузка, ошибка,
// пустое состояние, скелетон. Единый вид во всём мини-аппе.

import { TONE, Tone, tint } from "../theme";

// Статусная «таблетка» с семантическим тоном. Единый вид статусов
// (ожидание / успех / расхождение / ошибка) во всех списках.
export function StatusPill({
  tone = "neutral",
  children,
}: {
  tone?: Tone;
  children: React.ReactNode;
}) {
  const c = TONE[tone];
  return (
    <span
      className="text-xs px-2 py-0.5 rounded-full whitespace-nowrap font-medium"
      style={{ color: c, backgroundColor: tint(c) }}
    >
      {children}
    </span>
  );
}

export function Loading({ text = "Загрузка…" }: { text?: string }) {
  return (
    <div className="py-8 flex flex-col items-center gap-2 text-tg-hint">
      <div className="w-6 h-6 rounded-full border-2 border-tg-secondaryBg border-t-tg-accentText animate-spin" />
      <span className="text-sm">{text}</span>
    </div>
  );
}

export function SkeletonRows({ rows = 3 }: { rows?: number }) {
  return (
    <div className="space-y-2">
      {Array.from({ length: rows }).map((_, i) => (
        <div key={i} className="bg-tg-sectionBg rounded-xl p-3">
          <div className="h-3 w-1/3 rounded bg-tg-secondaryBg animate-pulse" />
          <div className="h-3 w-2/3 rounded bg-tg-secondaryBg animate-pulse mt-2" />
        </div>
      ))}
    </div>
  );
}

export function ErrorBox({ text }: { text: string }) {
  return (
    <div
      className="p-2 rounded-lg text-xs"
      style={{ color: TONE.danger, backgroundColor: tint(TONE.danger) }}
    >
      {text}
    </div>
  );
}

export function EmptyState({
  icon = "📭",
  text,
  action,
}: {
  icon?: string;
  text: string;
  action?: { label: string; onClick: () => void };
}) {
  return (
    <div className="py-10 text-center text-tg-hint">
      <div className="text-3xl mb-1">{icon}</div>
      <div className="text-sm">{text}</div>
      {action && (
        <button
          onClick={action.onClick}
          className="mt-3 px-4 py-2 rounded-lg bg-tg-button text-tg-buttonText text-sm font-medium"
        >
          {action.label}
        </button>
      )}
    </div>
  );
}
